import type { ReactNode } from "react";
import { cn } from "../../utils/utils";

interface EndOfTheListMessageProps {
  className?: string;
  hasItems?: boolean;
  endMessage?: string;
  emptyMessage?: string;
  children?: ReactNode;
}

export function EndOfTheListMessage({
  className,
  hasItems = true,
  endMessage = "Koniec listy szkoleń",
  emptyMessage = "Brak szkoleń w podanych kryteriach",
  children,
}: EndOfTheListMessageProps): JSX.Element {
  return (
    <div className={cn("flex justify-center text-center bg-slate-100 text-slate-400 rounded-2xl p-6 mt-5", className)}>
      <div className="text-center">
        {children ?? (hasItems ? endMessage : emptyMessage)}
      </div>
    </div>
  );
}
